import { put, call, takeLatest, cancelled } from "redux-saga/effects";

import axios from "axios";

import { simApi } from "../../../utility/api/apiList";

import productType from "./productType";
import { successFetchedProduct, failureFetchedProduct } from "./productAction";


export function* startfetchingProduct (action) {
  const cancelSource = axios.CancelToken.source()
  try {
         const response =  yield call(axios.get, simApi+action.search , { cancelToken: cancelSource.token })
         const handlesuccess = yield put(successFetchedProduct(response.data))
  } catch(error){
            const handlefailed=  yield put(failureFetchedProduct(''))
    
        }finally {
    if (yield cancelled()) {
      yield call(cancelSource.cancel)
    }
  }

}


export function* fetchProduct (){
yield takeLatest(productType.START_FETCHING_PRODUCT,startfetchingProduct )

}




